'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHighlightWords = require('react-highlight-words');

var _reactHighlightWords2 = _interopRequireDefault(_reactHighlightWords);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var highlightStyle = {
  backgroundColor: '#FDB02B'
};

var emptyArray = [];

var TextHighlighter = function TextHighlighter(_ref) {
  var text = _ref.text,
      enabled = _ref.enabled,
      words = _ref.words,
      style = _ref.style;
  return _react2.default.createElement(_reactHighlightWords2.default, {
    highlightStyle: highlightStyle,
    searchWords: enabled ? words : emptyArray,
    textToHighlight: text,
    autoEscape: true,
    style: style
  });
};

TextHighlighter.propTypes = {
  text: _propTypes2.default.string,
  words: _propTypes2.default.array,
  enabled: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

TextHighlighter.defaultProps = {
  enabled: 'false',
  words: [],
  text: '',
  style: {}
};

exports.default = TextHighlighter;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/text-highlighter/index.js
 ** module id = 380
 ** module chunks = 0
 **/